import { Edit, SimpleForm } from 'react-admin';
import { NewsForm } from './NewsForm.jsx';

export const NewsEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm><NewsForm /></SimpleForm>
  </Edit>
);
